import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import clsx from "clsx";
import BookingAction from "store/booking/BookingAction";
import {useCompetitions} from "utils/hooks/useCompetitions";
import CompetitionSelectedMark from "pages/Front/Booking/Competitions/components/CompetitionSelectedMark";
import FeatherIcon from "components/FeatherIcon";

const RenounceCompetitionItem = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {selectedCompetitions, freeCompetitionsCount, selectedFreeCompetitionsCount, renounceFreeCompetitions, removeNewlyAddedPaidCompetitions} =
        useCompetitions();

    if (freeCompetitionsCount === 0 || selectedFreeCompetitionsCount >= freeCompetitionsCount) {
        return null;
    }

    const onToggle = () => {
        const nextRenounceValue = !renounceFreeCompetitions;
        dispatch(BookingAction.setRenounceFreeCompetitions(nextRenounceValue));

        if (!nextRenounceValue && selectedFreeCompetitionsCount < freeCompetitionsCount) {
            removeNewlyAddedPaidCompetitions(selectedCompetitions);
        }
    };

    const missingCount = freeCompetitionsCount - selectedFreeCompetitionsCount;

    let title = "";
    let subtitle = "";
    let selectedTitle = "";

    if (selectedFreeCompetitionsCount === 0) {
        title = freeCompetitionsCount > 1 ? t("We don't want any inclusive competitions") : t("We don't want any inclusive competition");
        subtitle = t("Renunciation is binding.");
        selectedTitle = freeCompetitionsCount > 1 ? t("Renunciation chosen - no inclusive competitions") : t("Renunciation chosen - no inclusive competition");
    } else {
        title = t("We only want one inclusive competition"); // This might need adjustment if count > 2
        subtitle = t("Renunciation of the {{count}}. inclusive competition is binding.", {count: selectedFreeCompetitionsCount + 1});
        selectedTitle = t("Renunciation of the {{count}}. competition chosen", {count: selectedFreeCompetitionsCount + 1});
    }

    return (
        <div
            className={clsx(
                "RenounceCompetitionItem w-full flex flex-col overflow-hidden rounded-xl border-2 transition-colors duration-200",
                renounceFreeCompetitions ? "border-brand-yellow bg-[#FEFBF2]" : "border-[#E5E5E5] border-dashed bg-white"
            )}
        >
            <div className={"flex flex-col sm:flex-row sm:items-center gap-4 w-full px-4 py-4"}>
                <div className={"flex flex-row items-center gap-x-3 xs:gap-x-4 grow"}>
                    {renounceFreeCompetitions && <CompetitionSelectedMark />}
                    <div className={"flex flex-col lg:flex-row lg:items-center gap-x-8 grow"}>
                        <h3 className={"text-black text-base font-bold leading-tight"}>{renounceFreeCompetitions ? selectedTitle : title}</h3>
                        <span className={"text-xs font-semibold text-black"}>{subtitle}</span>
                    </div>
                </div>

                <div className={"w-full sm:w-auto flex justify-end"}>
                    <button
                        className={clsx(
                            "min-h-[32px] w-full sm:w-auto sm:min-w-[120px] flex flex-row items-center justify-center gap-x-1.5 shrink-0 rounded border border-black bg-white px-2 py-1 text-xs font-bold text-black leading-none hover:bg-gray-50",
                            renounceFreeCompetitions ? "border-black" : "border-gray-800"
                        )}
                        type={"button"}
                        onClick={onToggle}
                    >
                        {renounceFreeCompetitions ? (
                            <>
                                <FeatherIcon className={"size-5 shrink-0"} name={"x-circle"} />
                                <span className={"whitespace-nowrap"}>{t("Deselect")}</span>
                            </>
                        ) : (
                            <span className={"whitespace-nowrap"}>{t("Select")}</span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RenounceCompetitionItem;
